import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import stationaryIcon from "../../../../../assets/design-revamp-company/company-detail-headers/stationary-icon.svg";
import { useTranslation } from "react-i18next";
import { getStationaryList } from "../../../../../apis/Business/OtherVehicleApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import stationaryGraphic from "../../../../../assets/design-revamp-company/company-detail-headers/stationary-graphic-icon.svg";

const StationaryIcon = () => (
  <img src={stationaryIcon} alt="Water Icon" width={76} height={76} />
);

const StationaryHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjCombustion, setTotalObjCombustion] = useState([]);
  const [systemBoundaryCombustion, setSystemBoundaryCombustion] = useState("");
  useEffect(() => {
    getStationaryList({
      businessId: businessId,
      setTotalObj: setTotalObjCombustion,
      setSystemBoundaryCombustion: setSystemBoundaryCombustion,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`stationary-category ${className || ""}`}
      leftBoxProps={{
        icon: <StationaryIcon />,
        title: t("STATIONARY_COMBUSTION"),
        description: t("STATIONARY_COMBUSTION_INTRO"),
        scopes: [{ scope: t("OTHER_VEHICLE_SCOPE"), filled: true }],
        graphicIcons: [{ icon: stationaryGraphic }],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjCombustion,
                      totalObjCombustion?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} ${handleToFixedNum(
                  totalObjCombustion,
                  totalObjCombustion?.total_emissions
                )} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjCombustion,
                      totalObjCombustion.total_scope_1
                    ),
                    scopes: ["Scope 1"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjCombustion,
                      totalObjCombustion.total_scope_3
                    ),
                    scopes: ["S:3, C:8"],
                  },
                  {
                    value: handleToFixedNum(
                      totalObjCombustion,
                      totalObjCombustion.total_outside_scope
                    ),
                    scopes: ["Outside"],
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjCombustion?.updated_at
          ? formatDate(totalObjCombustion?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      systemBoundaryProps={{
        systemBoundary: systemBoundaryCombustion,
        setSystemBoundary: setSystemBoundaryCombustion,
        businessId: businessId,
        totalObjCategory: totalObjCombustion.category_name,
      }}
      {...props}
    />
  );
};

export default StationaryHeader;
